export const getTextWithHighlights = (text: string, searchQuery?: string) => {
  if (!searchQuery || !searchQuery.match(/[0-9a-zA-Z]/)) return text;
  const regex = new RegExp(searchQuery, 'gi');
  const highlightedText = text.replace(
    regex,
    `<mark data-testid="matching-text">$&</mark>`
  );
  return <span dangerouslySetInnerHTML={{ __html: highlightedText }} />;
};
